module.exports = __webpack_public_path__ + "static/media/menu-home.8f5437ca.svg";